const TOKEN_KEY = 'dockporter_token';
const REFRESH_TOKEN_KEY = 'dockie_refresh_token';


// Signup persistence helpers
const SIGNUP_STEP_KEY = 'dockie_signup_step';
const SIGNUP_DATA_KEY = 'dockie_signup_data';

export const setToken = (token) => {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  }
};

export const getToken = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  return token;
};

export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
};



export const setRefreshToken = (token) => {
  if (token) {
    localStorage.setItem(REFRESH_TOKEN_KEY, token);
  }
};

export const getRefreshToken = () => {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
};


const SIGNUP_IN_PROGRESS_KEY = "dockie_signup_in_progress";

export const setSignupInProgress = (inProgress) => {
  if (inProgress) {
    sessionStorage.setItem(SIGNUP_IN_PROGRESS_KEY, "1");
    return;
  }
  sessionStorage.removeItem(SIGNUP_IN_PROGRESS_KEY);
};

export const isSignupInProgress = () =>
  sessionStorage.getItem(SIGNUP_IN_PROGRESS_KEY) === "1";

export const setSignupStep = (step) => {
  localStorage.setItem(SIGNUP_STEP_KEY, step.toString());
};

export const getSignupStep = () => {
  const saved = localStorage.getItem(SIGNUP_STEP_KEY);
  return saved ? parseInt(saved) : 0;
};

export const setSignupData = (data) => {
  localStorage.setItem(SIGNUP_DATA_KEY, JSON.stringify(data));
};

export const getSignupData = () => {
  const saved = localStorage.getItem(SIGNUP_DATA_KEY);
  return saved ? JSON.parse(saved) : {
    email: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    phone: "",
    password: "",
    verificationCode: "",
    userType: "single",
    signupSource: "email",
  };
};

export const clearSignupData = () => {
  sessionStorage.removeItem(SIGNUP_IN_PROGRESS_KEY);
  localStorage.removeItem(SIGNUP_STEP_KEY);
  localStorage.removeItem(SIGNUP_DATA_KEY);
};

